import { useQuery } from '@apollo/client'
import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { useHistory, useParams } from 'react-router-dom'

import BookingConfirmed from '../../../src/assets/images/BookingConfirmed.png'
import { PAYMENT_CONFIRMATION_REFERENCE_QUERY } from '../../graphql/paymentConfirmation'
import { getTodayDate } from '../../helpers/date'
import { getInitialReferer } from '../../helpers/elements'
import { getTranslate, lang } from '../../localization'
import { useStyles } from './styles/index.styles'

function PaymentSucces() {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))
  const params = useParams<{
    hash: string
    reservationNumber: string
  }>()
  const { data, loading } = useQuery<{
    bookingDetailVoucher: {
      basicDetails: { displayReservationNumber: string }
    } | null
  }>(PAYMENT_CONFIRMATION_REFERENCE_QUERY, {
    variables: { hash: params.hash },
    skip: !params.hash,
    fetchPolicy: 'network-only'
  })
  const bookingNumber =
    data?.bookingDetailVoucher?.basicDetails?.displayReservationNumber

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <div className={classes.header}>
          <img src={BookingConfirmed} className={classes.img} />
          <div className={classes.right}>
            <div className={classes.headerRow}>
              <div>
                <Typography className={classes.title}>
                  {getTranslate('Congratulation, Booking Confirmed')}
                </Typography>
                <div className={classes.textRowChip} aria-live="polite">
                  <Typography
                    variant="h6"
                    className={classes.greyText}>{`${getTranslate(
                    'Reservation Number'
                  )}: `}</Typography>
                  <Typography variant="h6" className={classes.text}>
                    <bdi>
                      {bookingNumber ||
                        getTranslate(loading ? 'Loading...' : 'Unavailable')}
                    </bdi>
                  </Typography>
                </div>
              </div>
              <div className={classes.date}>
                <Typography variant="h6">
                  {`${getTranslate('Payment Date')}: ${getTodayDate(lang)}`}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.btnContainer}>
          <Button
            onClick={() => {
              history.push(`/vouherPdf/${params.hash}`)
            }}
            startIcon={<OpenInNewIcon className={classes.icon} />}>
            <Typography variant="h5" className={classes.blueText}>
              {getTranslate('Get Voucher')}
            </Typography>
          </Button>
          <Button
            variant="text"
            className={classes.btn}
            onClick={() => {
              const initialRef = getInitialReferer()
              window.location.href = initialRef || '/'
            }}>
            <Typography variant="h5" className={classes.redText}>
              {getTranslate(isSmall ? 'Booking ' : 'Back to Booking')}
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PaymentSucces
